

































































































































































































import Vue from 'vue';
import i18n from 'vue-i18n';
import { cloneDeep } from 'lodash';

import EventBus from '@/eventBus';
import axios from 'axios';
import CoSkeleton from '../../../../Atoms/co-skeleton/CoSkeleton.vue';
import CoCard from '../../../../Molecules/co-card/CoCard.vue';
import CoHeadline from '../../../../Atoms/co-headline/CoHeadline.vue';
import CoButton from '../../../../Atoms/co-button/CoButton.vue';
import CoCheckbox from '../../../../Atoms/co-checkbox/CoCheckbox.vue';
import CoText from '../../../../Atoms/co-text/CoText.vue';

export default {
    i18n: {
        messages: {
            en: {
                user: {
                    user_post_created: 'Someone created a post',
                    user_public_page_created: 'Someone created a page',
                    user_event_created: 'Someone created an event',
                    comment_on_post: 'Someone has commented on my post',
                    mention_in_post: 'Someone mentioned me in a post',
                    mention_in_comment: 'Someone mentioned me in a comment',
                    comment_under_post_i_interacted_with: 'Someone commented under a post I interacted with',
                    reaction_on_post: 'Someone reacted on a post',
                    reaction_on_comment: 'Someone reacted on a comment',
                    reminder_about_upcoming_events: 'Reminder about upcoming events',
                    new_rsvp_in_event: 'New attendee in my event',
                    participant_left_event: 'User cancelled participation in my event',
                    post_in_event_i_attend: 'New post in an event I attend',
                    i_was_add_to_event_as_organizer: 'I was added to an event as organizer',
                    new_follower_in_page: 'New follower in my page',
                    i_was_added_to_page: 'I was added to a page as owner or contributor',
                    post_in_page_i_follow: 'New post created in a page I follow',
                    market_item_interest: 'New Interest in my market item',
                    announcement: 'Announcement was made',
                    new_message: 'New message',
                    content_that_might_interest: 'Content that might interest me',
                    user_update_in_public_page_created: 'Someone created a post in a public page',
                    user_market_item_created: 'Someone created a market item',
                },
                admin: {
                    membership_plan_change: 'Membership plan changed',
                    membership_plan_renewal: 'Membership plan renewed',
                    membership_plan_cancellation: 'Membership plan cancelled',
                    membership_plan_upcoming_change_cancelation: 'Membership plan upcoming change cancelled',
                    membership_plan_created: 'Membership plan created',
                    user_created: 'User created',
                    user_waiting_for_approval: 'User waiting for approval',
                    user_waiting_for_approval_but_approved_domain:
                        'User waiting for approval but with approved domain email',
                    admin_post_created: '@:user.user_post_created',
                    admin_public_page_created: '@:user.user_public_page_created',
                    admin_event_created: '@:user.user_event_created',
                    admin_update_in_public_page_created: '@:user.user_update_in_public_page_created',
                    admin_market_item_created: '@:user.user_market_item_created',
                    purchase_withdrawal_admin: 'A purchase withdrawal was submitted',
                },
            },
            de: {
                user: {
                    user_post_created: 'Jemand einen Beitrag erstellt',
                    user_public_page_created: 'Jemand eine Seite erstellt',
                    user_event_created: 'Jemand eine Veranstaltung erstellt',
                    comment_on_post: 'Jemand meinen Beitrag kommentiert',
                    mention_in_post: 'Jemand mich in einem Beitrag erwähnt',
                    mention_in_comment: 'Jemand mich in einem Kommentar erwähnt',
                    comment_under_post_i_interacted_with:
                        'Jemand einen Kommentar unter einem Beitrag hinterlassen hat, mit dem ich interagiert habe',
                    reaction_on_post: 'Jemand auf meinen Beitrag reagiert',
                    reaction_on_comment: 'Jemand auf meinen Kommentar reagiert',
                    reminder_about_upcoming_events: 'Erinnerung an bevorstehende Veranstaltungen',
                    new_rsvp_in_event: 'Neue:r Teilnehmer:in in meiner Veranstaltung',
                    participant_left_event: 'Teilnehmer:in hat die Teilnahme an meiner Veranstaltung abgesagt',
                    post_in_event_i_attend:
                        'Jemand einen Beitrag in einer Veranstaltung erstellt hat, an der ich teilnehme',
                    i_was_add_to_event_as_organizer: 'Ich wurde einer Veranstaltung als Organisator:in hinzugefügt',
                    new_follower_in_page: 'Neuer Follower auf meiner Seite',
                    i_was_added_to_page: 'Ich wurde zu einer Seite als Eigentümer oder Mitwirkender hinzugefügt',
                    post_in_page_i_follow: 'Neuer Beitrag auf einer Seite, der ich folge',
                    market_item_interest: 'Neues Interesse an meinem Marktartikel',
                    announcement: 'Eine Ankündigung wurde gemacht',
                    new_message: 'Neue Nachricht',
                    content_that_might_interest: 'Inhalt, der mich interessieren könnte',
                    user_update_in_public_page_created: 'Jemand einen Beitrag in einer öffentlichen Seite erstellt',
                    user_market_item_created: 'Jemand einen Marktartikel erstellt',
                },
                admin: {
                    membership_plan_created: 'Mitgliedschaftsplan erstellt',
                    membership_plan_change: 'Mitgliedschaftsplan geändert',
                    membership_plan_renewal: 'Mitgliedschaftsplan erneuert',
                    membership_plan_cancellation: 'Mitgliedschaftsplan gekündigt',
                    membership_plan_upcoming_change_cancelation:
                        'Bevorstehende Änderung des Mitgliedschaftsplans storniert',
                    user_created: 'Benutzer:in erstellt',
                    user_waiting_for_approval: 'Benutzer:in wartet auf Genehmigung',
                    user_waiting_for_approval_but_approved_domain:
                        'Benutzer:in wartet auf Genehmigung, aber mit genehmigter Domain-E-Mail',
                    admin_post_created: '@:user.user_post_created',
                    admin_public_page_created: '@:user.user_public_page_created',
                    admin_event_created: '@:user.user_event_created',
                    admin_update_in_public_page_created: '@:user.user_update_in_public_page_created',
                    admin_market_item_created: '@:user.user_market_item_created',
                    purchase_withdrawal_admin: 'Ein Widerruf wurde eingereicht',
                },
            },
        },
    },
    name: 'NotificationsPreferences',

    components: {
        CoSkeleton,
        CoCard,
        CoHeadline,
        CoButton,
        CoCheckbox,
        CoText,
    },
    props: {
        admin: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            // default settings for all keys used to display the checkboxes
            settingsAllKeys: {
                user: {
                    // post
                    user_post_created: { push: true, email: true, in_app: true },
                    comment_on_post: { push: true, email: true, in_app: true },
                    mention_in_post: { push: true, email: true, in_app: true },
                    mention_in_comment: { push: true, email: true, in_app: true },
                    comment_under_post_i_interacted_with: { push: true, email: true, in_app: true },
                    reaction_on_post: { push: true, email: true, in_app: true },
                    reaction_on_comment: { push: true, email: true, in_app: true },
                    // event
                    user_event_created: { push: true, email: true, in_app: true },
                    reminder_about_upcoming_events: { push: true, email: true, in_app: true },
                    new_rsvp_in_event: { push: true, email: true, in_app: true },
                    participant_left_event: { push: true, email: true, in_app: true },
                    post_in_event_i_attend: { push: true, email: true, in_app: true },
                    i_was_add_to_event_as_organizer: { push: true, email: true, in_app: true },
                    // page
                    new_follower_in_page: { push: true, email: true, in_app: true },
                    i_was_added_to_page: { push: true, email: true, in_app: true },
                    post_in_page_i_follow: { push: true, email: true, in_app: true },
                    // market
                    market_item_interest: { push: true, email: true, in_app: true },
                    // announcement
                    announcement: { push: true, email: true, in_app: true },
                    // message
                    new_message: { push: true, email: true, in_app: true },
                    // suggested content
                    content_that_might_interest: { push: true, email: true, in_app: true },
                },
                admin: {
                    // admin notifications
                    membership_plan_created: { email: true },
                    membership_plan_cancellation: { email: true },
                    membership_plan_change: { email: true },
                    membership_plan_renewal: { email: true },
                    membership_plan_upcoming_change_cancelation: { email: true },
                    // new member
                    user_created: { push: true, email: true, in_app: true },
                    // approval notifications
                    user_waiting_for_approval: { email: true },
                    user_waiting_for_approval_but_approved_domain: { email: true },
                    // admin notifications about user generated content
                    admin_post_created: { push: true, email: true, in_app: true },
                    admin_public_page_created: { push: true, email: true, in_app: true },
                    admin_event_created: { push: true, email: true, in_app: true },
                    admin_update_in_public_page_created: { push: true, email: true, in_app: true },
                    admin_market_item_created: { push: true, email: true, in_app: true },
                    purchase_withdrawal_admin: { email: true },
                },
            },
            originalSettings: {},
            settings: null,
        };
    },
    computed: {
        // Keep marketplace preferences in sync when space settings load or change.
        isMarketOn() {
            return this.$store?.state?.space?.MarkeplaceOn || false;
        },
    },
    mounted() {
        this.getSettings();
    },
    methods: {
        wereChanged() {
            return JSON.stringify(this.settings) !== JSON.stringify(this.originalSettings);
        },
        patchSettings(input) {
            const settings = cloneDeep(input);
            // if settings do not contain all keys, add them with default values
            const flatDefault = JSON.parse(
                JSON.stringify({
                    ...this.settingsAllKeys.user,
                    ...this.settingsAllKeys.admin,
                })
            );

            // patch fetched values if some keys not provided by comparing to flatDefault
            Object.keys(flatDefault).forEach((key) => {
                if (!settings[key]) {
                    settings[key] = flatDefault[key];
                }
            });
            this.settings = cloneDeep(settings);
            this.originalSettings = cloneDeep(settings);
        },
        getSettings() {
            this.loading = true;
            axios({
                method: 'GET',
                url: '/notification/preferences',
            })
                .then((response) => {
                    if (response && response.data && response.data.settings) {
                        // if settings do not contain all keys, add them with default values
                        this.patchSettings(response.data.settings);
                    }
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    setTimeout(() => {
                        this.loading = false;
                    }, 1000);
                });
        },
        saveChanges() {
            this.loading = true;
            axios({
                method: 'PUT',
                data: { settings: this.settings },
                url: '/notification/preferences',
            })
                .then((response) => {
                    if (response && response.data && response.data.settings) {
                        this.patchSettings(response.data.settings);

                        EventBus.$emit('INFO', {
                            Message: this.$t('labels.changessaved'),
                        });
                    }
                })
                .catch((error) => {
                    EventBus.$emit('ERROR', {
                        Message: this.$t('labels.failedToSaveChanges'),
                    });
                })
                .finally(() => {
                    // timeout
                    setTimeout(() => {
                        this.loading = false;
                    }, 1000);
                });
        },
        discard() {
            this.getSettings();
        },
        randomPercents(from = 0, to = 100) {
            const percents = Math.floor(Math.random() * (to - from + 1) + from);
            return `${percents}%`;
        },
    },
};
